import React from 'react';

const IconAdd = () => {
	return <i className="fa-regular fa-plus"></i>;
};

export default IconAdd;